var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1998_1894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 8.75001C2.75 8.5069 2.84658 8.27374 3.01849 8.10183C3.19039 7.92992 3.42355 7.83334 3.66667 7.83334H18.3333C18.5764 7.83334 18.8096 7.92992 18.9815 8.10183C19.1534 8.27374 19.25 8.5069 19.25 8.75001V10.5833C19.25 10.8265 19.1534 11.0596 18.9815 11.2315C18.8096 11.4034 18.5764 11.5 18.3333 11.5H3.66667C3.42355 11.5 3.19039 11.4034 3.01849 11.2315C2.84658 11.0596 2.75 10.8265 2.75 10.5833V8.75001Z",
    stroke: "#FF626A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 7.83334V19.75",
    stroke: "#FF626A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 11.5V17.9167C17.4166 18.4029 17.2234 18.8692 16.8796 19.213C16.5358 19.5568 16.0695 19.75 15.5833 19.75H6.41659C5.93035 19.75 5.46404 19.5568 5.12022 19.213C4.77641 18.8692 4.58325 18.4029 4.58325 17.9167V11.5",
    stroke: "#FF626A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87492 7.83334C6.26713 7.83334 5.68424 7.59189 5.25447 7.16212C4.82469 6.73235 4.58325 6.14946 4.58325 5.54167C4.58325 4.93388 4.82469 4.35099 5.25447 3.92122C5.68424 3.49145 6.26713 3.25 6.87492 3.25C7.75921 3.2346 8.62577 3.66366 9.36159 4.48123C10.0974 5.29881 10.6683 6.46696 10.9999 7.83334C11.3315 6.46696 11.9024 5.29881 12.6382 4.48123C13.3741 3.66366 14.2406 3.2346 15.1249 3.25C15.7327 3.25 16.3156 3.49145 16.7454 3.92122C17.1751 4.35099 17.4166 4.93388 17.4166 5.54167C17.4166 6.14946 17.1751 6.73235 16.7454 7.16212C16.3156 7.59189 15.7327 7.83334 15.1249 7.83334",
    stroke: "#FF626A",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1998_1894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.c7afea6f76668bc7ea9101cd50223d22.svg";
export { ForwardRef as ReactComponent };